import * as React from "react";
import { Modal } from "react-bootstrap";
import { getDate } from "../../../function";
import AiVishingTranscript from "../../ai-vishing-transcript/ai-vishing-transcript";
import AiChatTranscript from "../../ai-chat-transcript/ai-chat-transcript";
import ReplyModal from "../results/reply-modal";
import "../../rightside-modal/rightside-modal.css";
import "./activity-drawer.css";

/** Same badge classes as Results / campaign-edit User Details list */
function eventBadgeClass(message) {
	if (!message) return "badge badge-pill badge-soft-secondary";
	if (["Email Sent", "SMS Sent", "Call Initiated", "Sending", "Message Sent", "Email Reported"].includes(message)) return "badge badge-pill badge-soft-primary";
	if (message === "Email Opened" || message === "Call Transcript") return "badge badge-pill badge-soft-success";
	if (["Link Clicked", "Call Picked", "Call Received"].includes(message)) return "badge badge-pill badge-soft-warning";
	if (["Data Submitted", "Error", "System Hacked", "Attachment Opened", "Invalid Whatsapp #", "Invalid Telegram #", "Replied"].includes(message)) return "badge badge-pill badge-soft-danger";
	return "badge badge-pill badge-soft-secondary";
}

function eventLabel(event, attackType) {
	if (event.message === "Email Sent") return event.isDMI ? "Email Sent (DMI)" : "Email Sent (SMTP)";
	if (event.message === "Error") return attackType === "Phishing" ? (event.isDMI ? "Error DMI" : "Error SMTP") : "Error";
	return event.message || "—";
}

export default function ActivityDrawer(props) {
	const { show = false, onClose, handleModal, user, attackType } = props;
	const close = onClose || handleModal || (() => { });
	const target = user && user.target ? user.target : {};
	const first = (target.firstname || "").trim();
	const last = (target.lastname || "").trim();
	const initials = (first.charAt(0) + (last ? last.charAt(0) : first.charAt(1) || "")).toUpperCase() || "—";
	const displayName = [first, last].filter(Boolean).join(" ") || "—";
	const email = target.email || "—";
	const events = user && Array.isArray(user.events) ? user.events : [];

	const [openEventId, setOpenEventId] = React.useState(null);
	const [showReply, setShowReply] = React.useState(false);

	const onButtonClick = (eventId) => {
		setOpenEventId((prev) => (prev === eventId ? null : eventId));
	};

	return (
		<>
			<Modal
				className="info-filter mainfooterModal right-modal-wrap right"
				show={show}
				onHide={close}
				autoFocus
				keyboard
			>
				<Modal.Header className="activity-drawer-header" closeButton>
					<div className="d-flex align-items-center activity-drawer-header-user">
						<div className="activity-drawer-header-avatar">{initials}</div>
						<div className="ml-2">
							<div className="activity-drawer-header-name">{displayName}</div>
							<small className="activity-drawer-header-email text-muted">{email}</small>
						</div>
					</div>
				</Modal.Header>
				<div className="activity-drawer-timeline-bar">
					<span className="activity-drawer-timeline-label">Activity Timeline</span>
				</div>
				<Modal.Body>
					<div className="activity-drawer-timeline">
						{events.length ? events.map((event, index) => {
							try {
								var details = event.message === "Error" && event.details ? JSON.parse(JSON.stringify(event.details)) : event.details;
								return (
									<div className="activity-drawer-timeline-item" key={event.id || `event-${index}`}>
										<div className="activity-drawer-timeline-dot" />
										<div className="activity-drawer-timeline-content">
											<div className="activity-drawer-timeline-title">
												<span className={eventBadgeClass(event.message)}>{eventLabel(event, attackType)}</span>
												<span className="text-muted ml-2" style={{ fontSize: "10px" }}>{getDate(event.createdAt)}</span>
											</div>
											{event.ip && <small className="text-muted">IP: {event.ip}</small>}


											{openEventId === event.id && details && (
												<div className="userviewDetails" style={{ padding: '10px !important' }}>
													{typeof details === 'object' && event.message !== "Call Transcript" && event.message !== "Chat Transcript" ?
														Object.keys(details).map((key, i, arr) => (
															<div className="row" key={"details-" + i}>
															  <p className={`col-sm-4 key-Text ${i === arr.length - 1 ? "no-margin" : ""}`}>
																{key}
															  </p>
															  <p className={`col-sm-8 value-Text ${i === arr.length - 1 ? "no-margin" : ""}`}>
																{details[key]}
															  </p>
															</div>
														  )) :
														<div>
															{event.message === "Call Transcript" ? 
																<AiVishingTranscript 
																	dataString={
																	typeof details?.info === "string" 
																		? details.info 
																		: JSON.stringify(details?.info ?? "")
																	} 
																/>: 
																event.message === "Chat Transcript" ?
																<AiChatTranscript 
																	dataString={
																	typeof details?.info === "string" 
																		? details.info 
																		: JSON.stringify(details?.info ?? "")
																	} 
																/>:
																<>
																	<h6>Message</h6>
																	<p className="mb-0" style={{ fontSize: '13px' }}>{details}</p>
																</>
															}
														</div>
													}
												</div>
											)}

											<h6 className="mt-2">
												{details && Object.keys(details).length && (
													event.message === "Error" ||
													event.message === "System Hacked" ||
													event.message === "Data Submitted" ||
													event.message === "Call Transcript" || 
													event.message === "Chat Transcript"
												) ? (
													<span onClick={() => onButtonClick(event.id)} style={{ color: "#5670e7", cursor: "pointer", fontSize: "12px" }}>
														{openEventId === event.id ? "Hide Details" : "View Details"}
													</span>
												) : null}
												{event.message === "Replied" && user.uIds && user.uIds.length && user.uIds[0].buffer ? (
													<span onClick={() => setShowReply(true)} style={{ color: "#5670e7", cursor: "pointer", fontSize: "12px" }}>
														View Reply Details
													</span>
												) : null}
											</h6>


										</div>
									</div>
								);
							} catch (err) {
								return null;
							}
						}) : (
							<p className="text-muted mb-0">No activity yet.</p>
						)}
					</div>
				</Modal.Body>
			</Modal>
			<ReplyModal
				show={showReply}
				handleClose={() => setShowReply(false)}
				buffer={user && user.uIds && user.uIds.length && user.uIds[0].buffer}
			/>
		</>
	);
}
